// External dependencies
import jQuery from 'jquery';

// WordPress dependencies
import apiFetch from '@wordpress/api-fetch';

jQuery( document ).ready( function() {
	let lastClickedButton = null;
	let isProcessing = false;
	
	// Cross-browser button capture
	function captureButtonClick() {
		jQuery( '.post-type-coca_bais_carousel form#post input[type="submit"], .post-type-coca_bais_carousel form#post button[type="submit"]' ).on( 'click touchstart', function( e ) {
			lastClickedButton = jQuery( this );
			lastClickedButton.clickedAt = Date.now();
			lastClickedButton.buttonName = jQuery( this ).attr( 'name' ) || '';
			lastClickedButton.buttonValue = jQuery( this ).val() || jQuery( this ).text() || '';
			lastClickedButton.buttonId = jQuery( this ).attr( 'id' ) || '';
		} );
	}
	
	// Initialize button capture
	captureButtonClick();
	
	// Cross-browser publish action detection
	function isPublishAction( button ) {
		if ( ! button ) return false;
		
		const name = button.buttonName || button.attr( 'name' ) || '';
		const value = button.buttonValue || button.val() || button.text() || '';
		const id = button.buttonId || button.attr( 'id' ) || '';
		const className = button.attr( 'class' ) || '';
		
		return (
			name === 'publish' || 
			value === 'Publish' ||
			value.indexOf( 'Publish' ) !== -1 ||
			id === 'publish' ||
			id.indexOf( 'publish' ) !== -1 ||
			className.indexOf( 'publish' ) !== -1 ||
			className.indexOf( 'editor-post-publish-button' ) !== -1
		);
	}
	
	// Form submission handler
	jQuery( '.post-type-coca_bais_carousel form#post' ).on( 'submit', function( event ) {
		// Check if we should bypass (form was already processed)
		if ( jQuery( 'input[name="_bais_carousel_bypass"]' ).length > 0 ) {
			return true; // Let form submit normally
		}
		
		// Prevent double processing
		if ( isProcessing ) {
			return false;
		}
		
		let savedOptions;
		try {
			savedOptions = window.localStorage.getItem( 'coca_bais_carousel_data' );
		} catch ( e ) {
			console.warn( 'localStorage not available:', e );
			return true; // Let form submit normally
		}
		
		if ( ! savedOptions ) return true; // Let form submit normally
		
		const form = this;
		let clickedButton = lastClickedButton;
		
		// Fallback button detection
		if ( ! clickedButton || ( Date.now() - ( clickedButton.clickedAt || 0 ) ) > 5000 ) {
			clickedButton = jQuery( document.activeElement );
			
			if ( ! clickedButton || ! clickedButton.is( 'input, button' ) ) {
				clickedButton = jQuery( form ).find( 'input[name="publish"], button[name="publish"], #publish, .editor-post-publish-button' ).first();
			}
		}
		
		const publishAction = isPublishAction( clickedButton );
		
		let parsedData;
		try {
			parsedData = JSON.parse( savedOptions );
		} catch ( e ) {
			console.error( 'Invalid localStorage JSON:', e );
			
			const continueAnyway = confirm( 'Invalid meta data format. Do you want to continue anyway?' );
			if ( ! continueAnyway ) {
				event.preventDefault();
				return false;
			}
			return;
		}
		
		if ( parsedData && typeof parsedData === 'object' ) {
			event.preventDefault();
			isProcessing = true;
			
			// Prepare API data
			parsedData.post_id = jQuery( '#post_ID' ).val();
			parsedData.intended_status = publishAction ? 'publish' : 'draft';
			
			// API call
			let apiCall;
			if ( typeof wp !== 'undefined' && wp.apiFetch ) {
				apiCall = wp.apiFetch( {
					path: '/coca-bais/v1/save-carousel-meta',
					method: 'POST',
					data: parsedData,
				} );
			} else if ( typeof apiFetch !== 'undefined' ) {
				apiCall = apiFetch( {
					path: '/coca-bais/v1/save-carousel-meta',
					method: 'POST',
					data: parsedData,
				} );
			} else {
				// Fallback to jQuery AJAX
				apiCall = jQuery.ajax( {
					url: '/wp-json/coca-bais/v1/save-carousel-meta',
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify( parsedData ),
					beforeSend: function( xhr ) {
						const nonce = jQuery( '#_wpnonce' ).val() || jQuery( 'input[name="_wpnonce"]' ).val();
						if ( nonce ) {
							xhr.setRequestHeader( 'X-WP-Nonce', nonce );
						}
					},
				} );
			}
			
			// Handle API response
			apiCall.then( function( response ) {
				submitFormSafely( form, publishAction, false );
			} ).catch( function( error ) {
				console.error( 'API Error:', error );
				
				// Ask user what to do
				const tryAgain = confirm( 'Failed to save carousel settings. Would you like to try submitting the form anyway?' );
				if ( tryAgain ) {
					submitFormSafely( form, publishAction, true );
				} else {
					isProcessing = false;
				}
			} );
		}
	} );

	// Safe form submission function
	function submitFormSafely( form, isPublish, bypassValidation ) {
		// Clean up localStorage
		try {
			window.localStorage.removeItem( 'coca_bais_carousel_data' );
		} catch ( e ) {
			// Ignore localStorage errors
		}
		
		// Create and append hidden field to indicate we should bypass our handler
		const bypassField = document.createElement( 'input' );
		bypassField.type = 'hidden';
		bypassField.name = '_bais_carousel_bypass';
		bypassField.value = '1';
		form.appendChild( bypassField );
		
		// Set the post status appropriately
		if ( isPublish ) {
			// Ensure post status is set to publish
			let statusField = form.querySelector( 'input[name="post_status"]' );
			if ( ! statusField ) {
				statusField = document.createElement( 'input' );
				statusField.type = 'hidden';
				statusField.name = 'post_status';
				form.appendChild( statusField );
			}
			statusField.value = 'publish';
			
			// Also set the original_post_status hidden field if present
			const originalStatus = form.querySelector( 'input[name="original_post_status"]' );
			if ( originalStatus ) {
				originalStatus.value = 'publish';
			}
			
			// Add publish action
			const publishAction = document.createElement( 'input' );
			publishAction.type = 'hidden';
			publishAction.name = 'publish';
			publishAction.value = 'Publish';
			form.appendChild( publishAction );
		}
		
		// Use native form submit to avoid triggering jQuery handlers
		isProcessing = false;
		form.submit();
	}
} );
